import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as CloseIcon } from "../../svg/close-icon.svg";
import { ReactComponent as ArrowLeftIcon } from "../../svg/arrow-left-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../svg/arrow-right-icon.svg";
import * as Styled from './GalleryOverlay.styles';
import { data } from './GalleryOverlay.data';
import { pageMotionProps } from 'utils/styles/animations';
import { isMobile } from 'utils/platform';
import useGlobalStore from 'utils/store';

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Controller } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";

interface ISwiper {
  activeIndex: number;
  slideNext: () => void;
  slidePrev: () => void; 
  clickedIndex: () => void;
  disable: () => void;
  slideTo: (index: number, speed: number) => void;
}

export interface GalleryOverlayProps {
  onClose: () => void,
}
const GalleryOverlay: React.FC<GalleryOverlayProps> = ({onClose}) => {
  const [galleryData, setGalleryData] = useState<string[]>([]);
  const fullGalleryRef = useRef<ISwiper>();
  const thumbsGalleryRef = useRef<ISwiper>();
  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);

  const { copy } = useGlobalStore();

  useEffect(() => {
    if (galleryData.length === 0) {
      if (isMobile()) {
        setGalleryData(data.mobile);
      } else {
        setGalleryData(data.desktop);
      } 
    }
  }, [galleryData]);

  return <Styled.Wrapper {...pageMotionProps}>
    <Styled.Content>
      <Styled.CloseWrapper>
        <CloseIcon onClick={()=>{
          onClose();
          thumbsGalleryRef.current?.disable()
          fullGalleryRef.current?.disable()
        }}/>
      </Styled.CloseWrapper>
      <Styled.ContentTitle
        dangerouslySetInnerHTML={{ __html: copy.gallery.title }} />
      <Styled.ContentSubtitle
        dangerouslySetInnerHTML={{ __html: copy.gallery.subtitle }} />
    </Styled.Content>
      <Styled.ContentControls>
        <ArrowLeftIcon onClick={()=>{
          thumbsGalleryRef.current?.slidePrev();
        }}/>
        <ArrowRightIcon onClick={()=>{
          thumbsGalleryRef.current?.slideNext();
        }}/>
      </Styled.ContentControls>

      <Styled.FullCarouselWrapper>
        <Swiper
            slidesPerView={1}
            centeredSlides={true}
            className="FullCarouselWrapper"
            onSwiper={(swiper: any) => {
              fullGalleryRef.current = swiper;
              setFirstSwiper(swiper);
            }}
            modules={[Controller]}
            controller={{ control: secondSwiper }}
          >
            {galleryData.map((item: string | undefined, index: React.Key | null | undefined) => (
              <SwiperSlide key={index}>
                <Styled.CarouselItemOverlay />
                <Styled.Image src={item} />
              </SwiperSlide>
            ))}
          </Swiper>
      </Styled.FullCarouselWrapper>
      <Styled.ThumbsCarouselWrapper>
        <Swiper
            effect={"coverflow"}
            slidesPerView={"auto"}
            spaceBetween={150}
            centeredSlides={true}
            coverflowEffect={{
              rotate: 0,
              stretch: 30,
              depth: 150,
              modifier: 1.5,
              slideShadows: false,
            }}
            freeMode={true}
            modules={[EffectCoverflow, Controller]}
            controller={{ control: firstSwiper }}
            className="ThumbsCarouselWrapper"
            onSwiper={(swiper: any) => {
              thumbsGalleryRef.current = swiper;
              setSecondSwiper(swiper);
            }}
          >
            {galleryData.map((item: string | undefined, index: number) => (
              <SwiperSlide key={index} onClick={() => {
                fullGalleryRef.current?.slideTo(index, 600)
              }}>
                <Styled.CarouselItemOverlay />
                <Styled.Image src={item} />
              </SwiperSlide>
            ))}
          </Swiper>
      </Styled.ThumbsCarouselWrapper>
  </Styled.Wrapper>;
};

export default GalleryOverlay;
